export default __webpack_public_path__ + "static/media/icon-remove-image.b35f4616.svg";